import * as types from "../constants/actionTypes";
import { cloneDeep, isEqual } from "lodash";

export const inHomeInitialState = function () {
    return {
        selectedUsers: [],
        prefilledDataPending: null,
        prefilledData: null,
        prefilledCities: null,
        serviceLocationContactInfo: null,
        getVaccinePending: null,
        getVaccineResult: null, // result ex {data: '', success: true, errorMsg: null}
        selectedVaccines: null,
        getEligibilityQPending: null,
        getEligibilityQResult: null,
        eligibilityResponses: null,
        getAvailableApptsPending: null,
        getAvailableApptsResult: null,
        selectedDateTime: null,
        bookApptPending: null,
        bookApptResult: null,
        finalConfirmationDetails: null,
    }
};

export default function inHomeReducer(state = inHomeInitialState(), action) {
    switch (action.type) {

        //every time users is set, clear data that is later in the scheduling flow
        case types.SET_SELECTED_USERS:
            return { ...inHomeInitialState(), selectedUsers: action.selectedUsers, };

        case types.GET_INHOME_PREFILL:
            return { ...state, prefilledDataPending: true, }

        case types.GET_INHOME_PREFILL_RESULT:
            return { ...state, prefilledData: action.data, prefilledCities: action.data.cities, serviceLocationContactInfo: null, prefilledDataPending: false }

        //every time loc is set, and it is different than before, clear data that is later in the scheduling flow
        case types.SET_INHOME_LOCATION:
            if (!isEqual(state.serviceLocationContactInfo, action.address)) {
                return {
                    ...state, serviceLocationContactInfo: action.address,
                    getVaccinePending: null,
                    getVaccineResult: null, // result ex {data: '', success: true, errorMsg: null}
                    selectedVaccines: null,
                    getEligibilityQPending: null,
                    getEligibilityQResult: null,
                    eligibilityResponses: null,
                    getAvailableApptsPending: null,
                    getAvailableApptsResult: null,
                    selectedDateTime: null,
                    bookApptPending: null,
                    bookApptResult: null,
                    finalConfirmationDetails: null
                }
            } else return { ...state }

        case types.GET_INHOME_VACCINES:
            return { ...state, getVaccinePending: true, getVaccineResult: null }

        case types.GET_INHOME_VACCINES_RESULT:
            return { ...state, getVaccineResult: action.data, getVaccinePending: false }

        //every time vaccines is set, and it is different than before,  clear data that is later in the scheduling flow
        case types.SET_INHOME_VACCINES:
            if (!isEqual(state.selectedVaccines, action.data)) {
                return {
                    ...state, selectedVaccines: action.data,
                    getEligibilityQPending: null,
                    getEligibilityQResult: null,
                    eligibilityResponses: null,
                    getAvailableApptsPending: null,
                    getAvailableApptsResult: null,
                    selectedDateTime: null,
                    bookApptPending: null,
                    bookApptResult: null,
                    finalConfirmationDetails: null
                }
            } else return { ...state }

        case types.GET_INHOME_ELIGIBILITY_Q:
            return { ...state, getEligibilityQResult: null, getEligibilityQPending: true, }

        case types.GET_INHOME_ELIGIBILITY_Q_RESULT:
            return { ...state, getEligibilityQResult: action.data, getEligibilityQPending: false }

        case types.REMOVE_VACCINE: {
            let newSelectedVaccines = state.selectedVaccines.map((user) => {
                if (user.mrn === action.userMrn) {
                    user.vaccines = user.vaccines.map((vacc) => {
                        if (vacc.displayName === action.vaccineName) {
                            vacc.isChecked = false;
                        }
                        return vacc;
                    })
                }
                return user
            })

            return { ...state, selectedVaccines: newSelectedVaccines }
        }

        //every time eligibility is set, and it is different than before,  clear data that is later in the scheduling flow
        case types.SEND_INHOME_ELIGIBILITY_RESPONSES:
            if (!isEqual(state.eligibilityResponses, action.response)) {
                return {
                    ...state, eligibilityResponses: action.response,
                    getAvailableApptsPending: null,
                    getAvailableApptsResult: null,
                    selectedDateTime: null,
                    bookApptPending: null,
                    bookApptResult: null,
                    finalConfirmationDetails: null
                }
            } else return { ...state }

        case types.GET_INHOME_APPTS:
            return { ...state, getAvailableApptsPending: action.secret ? false : true }

        case types.GET_INHOME_APPTS_RESULT:
            return { ...state, getAvailableApptsPending: false, getAvailableApptsResult: action.data }

        //every time appt time is set, and it is different than before,  clear data that is later in the scheduling flow
        case types.SET_INHOME_DATETIME:
            if (!isEqual(state.selectedDateTime, action.selectedDateTime)) {
                return {
                    ...state, selectedDateTime: action.selectedDateTime,
                    bookApptPending: null,
                    bookApptResult: null,
                    finalConfirmationDetails: null
                }
            } else return { ...state }

        case types.BOOK_INHOME_APPT:
            return { ...state, bookApptPending: true }

        case types.BOOK_INHOME_APPT_RESULT:
            // if booking the appt was successful, clear out state (after cloning into a separate section for confirmation details)
            if (action.data.success) {
                let finalConfirmationDetails = {
                    serviceLocationContactInfo: cloneDeep(state.serviceLocationContactInfo),
                    selectedDateTime: cloneDeep(state.selectedDateTime),
                    selectedVaccines: cloneDeep(state.selectedVaccines)
                }
                return { ...inHomeInitialState(), bookApptPending: false, bookApptResult: action.data, finalConfirmationDetails, prefilledCities: cloneDeep(state.prefilledCities) }
            }
            else {
                return { ...state, bookApptPending: false, bookApptResult: action.data }
            }

        case types.LOGOUT_COMPLETED:
            return inHomeInitialState();

        case types.CANCEL_INHOME_BOOKING:
            return inHomeInitialState();


        default:
            return { ...state };
    }
}

